
import {
  Component,
  // Prop,
  Vue
  // Model,
  // Provide,
  // Watch
} from "vue-property-decorator";
import devStatistics from "./components/dev-statistics.vue";
import devTable from "./components/dev-table.vue";
import { getDeviceInitData } from "@/api/api-basic";
import { objAny } from "@/common/common-interface";
@Component({
  components: {
    "pi-dev-statistics": devStatistics,
    "pi-dev-table": devTable
  }
})
export default class SystemEquipment extends Vue {
  private initData: objAny = {};

  async getDeviceInitData(): Promise<void> {
    const ret = await getDeviceInitData({});
    if (ret.status === this.$config.apiStatus) {
      this.initData = ret.data[0];
    }
  }
  mounted() {
    this.getDeviceInitData();
  }
}
